import { BrowserRouter } from "react-router-dom";
import "./App.css";
import SiteSetup from "./components/PageSetup";
import Router from "./components/Router";
import { LanguageProvider } from "./localization/LanguageContext";

function App() {
	return (
		<LanguageProvider>
			<SiteSetup />
			<BrowserRouter>
				<Router />
			</BrowserRouter>
		</LanguageProvider>
	);
}

export default App;
